import { createApp } from 'vue'
import App from './App.vue'
import router from '@/helper/router'
import { setUpValidatorRules } from '@/helper/ValidationRules'
import AirbagDirective from '@/helper/directives/Airbag'
import i18n from '@/helper/Translations'
import ValidateDirective from './helper/ValidateDirective'
import SanitizeHtml from '@/helper/directives/SanitizeHtml'

const app = createApp(App)

app.use(i18n)
app.use(router)

app.directive('airbag', AirbagDirective)
app.directive('validate', ValidateDirective)
app.directive('sanitize-html', SanitizeHtml)

setUpValidatorRules()

app.mount('#app')
